import {
    createContext,
    Dispatch,
    FC,
    PropsWithChildren,
    SetStateAction,
    useContext,
    useState
} from 'react';
import { useBoolean } from 'hooks';

type StateContext = {
    callback: (ok: boolean) => void;
    setCallback: Dispatch<SetStateAction<(ok: boolean) => void>>;
    isBlockModalOpen: boolean;
    showBlockModal: () => void;
    hideBlockModal: () => void;
    setIsNavigationBlocked: Dispatch<SetStateAction<boolean>>;
    isNavigationBlocked: boolean;
};

export const BlockNavigationContext = createContext<StateContext>(null);

export const BlockNavigationProvider: FC<PropsWithChildren> = ({
    children
}) => {
    const [callback, setCallback] = useState(null);
    const [isBlockModalOpen, showBlockModal, hideBlockModal] = useBoolean();
    const [isNavigationBlocked, setIsNavigationBlocked] = useState(false);

    return (
        <BlockNavigationContext.Provider
            value={{
                callback,
                setCallback,
                isBlockModalOpen,
                showBlockModal,
                hideBlockModal,
                isNavigationBlocked,
                setIsNavigationBlocked
            }}>
            {children}
        </BlockNavigationContext.Provider>
    );
};

export const useBlockNavigation = () => useContext(BlockNavigationContext);
